import { Card } from 'components/atoms';

import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';

import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetInfiniteLabelBalance } from 'services/balance';
import { BALANCE_TYPE, IFinancesDetail, INCOME_TYPE } from 'services/balance/types';

import { formatCurrency } from 'utils/global/currency.utils';

import { getNodes } from 'utils/table/nodes.utils';

enum SORT_COLUMNS {
  name,
  amountToRepayment,
  net,
  gross,
  tax,
  type,
  file,
}

const Balance = () => {
  const columnsVisibility = useTableColumnsVisibility('Balance1', SORT_COLUMNS);

  const balances = useGetInfiniteLabelBalance();

  const tableData = getNodes<IFinancesDetail>(balances.data?.pages.flat() || []);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const i18nextPrefix = 'balance';

  const onNavigate = (balance: IFinancesDetail) => {
    if (balance.type === BALANCE_TYPE.cost) {
      navigate(`cost/${balance.id}/data`);
    }
    if (balance.type === BALANCE_TYPE.income) {
      navigate(`income/${balance.id}/data`);
    }
  };

  return (
    <TopbarPage
      topbarAbsolute
      topbar={
        <TopBar
          title={t(`${i18nextPrefix}.title.list`)}
          customBackItem={<div />}
          // topbarContent={
          //   <Table.CustomColumnsButton
          //     columns={SORT_COLUMNS}
          //     isClear
          //     visibility={columnsVisibility}
          //     i18nextPrefix={i18nextPrefix}
          //   />
          // }
        ></TopBar>
      }
    >
      <ListWrapper
        view="list"
        style={{ paddingBottom: 100 }}
        items={balances.data?.pages.flat()}
        isLoading={balances.isLoading}
        isFetchingNextPage={balances.isFetchingNextPage}
        item={(balance) => (
          <Card
            view="list"
            key={balance.id}
            header={balance.name}
            description={t(`enum.INCOME_TYPE.${INCOME_TYPE[balance.incomeType]}`)}
            onClick={() => onNavigate(balance)}
            status={
              <div className="flex flex-col w-max  items-end ">
                <p className="font-bold" style={{ fontSize: 18 }}>
                  {balance.type === BALANCE_TYPE.cost &&
                    `(${formatCurrency(balance.amountToRepayment)})`}{' '}
                  {formatCurrency(balance.amount.netAmount)}
                </p>
                <p className="opacity-65" style={{ fontSize: 14 }}>
                  {balance.tax}% {formatCurrency(balance.amount.grossAmount)}
                </p>

                {/* <Button
                  type='button'
                  isClear
                  onlyIcon
                  disabled={!settlement.filePath}
                  onClick={() =>
                    setFile({
                      id: settlement.id,
                      name: settlement.settlementNumber,
                    })
                  }>
                  <Button.Icon icon={<PiDownload />} />
                </Button> */}
              </div>
            }
          />
        )}
      />
      {/* <Table
        id={columnsVisibility.tableId}
        select={select}
        columns={[
          {
            label: t("input.label.name"),
            renderCell: ({ name }) => (
              <TableItem>
                <TableItem.Text text={name} />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.name),
            resize: true,
          },

          {
            label: t("input.label.amountToRepayment"),
            renderCell: ({ type, amountToRepayment }) => (
              <TableItem>
                <TableItem.Currency
                  text={
                    type === BALANCE_TYPE.cost
                      ? formatCurrency(amountToRepayment, {
                          length: 2,
                        })
                      : undefined
                  }
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.amountToRepayment),
            resize: true,
          },
          {
            label: t("input.label.net"),
            renderCell: ({ amount }) => (
              <TableItem>
                <TableItem.Currency
                  text={formatCurrency(amount.netAmount, {
                    length: 2,
                  })}
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.net),
            resize: true,
          },
          {
            label: t("input.label.gross"),
            renderCell: ({ amount }) => (
              <TableItem>
                <TableItem.Currency
                  text={formatCurrency(amount.grossAmount, {
                    length: 2,
                  })}
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.gross),
            resize: true,
          },
          {
            label: t("input.label.tax"),
            renderCell: ({ tax }) => (
              <TableItem>
                <TableItem.Currency
                  text={`${formatCurrency(tax, {
                    length: 2,
                    suffix: "%",
                  })} `}
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.tax),
            resize: true,
          },

          {
            label: t("input.label.type"),
            renderCell: ({ incomeType, type }) => (
              <TableItem>
                <LabeledIncomeStatus
                  status={
                    type === BALANCE_TYPE.income
                      ? incomeType === INCOME_TYPE.cost
                        ? INCOME_TYPE.basic
                        : incomeType
                      : INCOME_TYPE.cost
                  }
                />
              </TableItem>
            ),
            hide: columnsVisibility.hide(SORT_COLUMNS.type),
            resize: true,
          },

          {
            label: t("input.label.file"),
            renderCell: ({ fileUrl }) => (
              <TableItem justifyPosition="center">
                <a
                  href={fileUrl ?? ""}
                  download={fileUrl}
                  aria-disabled={!fileUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button type="button" isClear disabled={!fileUrl}>
                    <Button.Icon icon={<PiDownload />} />
                  </Button>
                </a>
              </TableItem>
            ),
            resize: true,
            hide: columnsVisibility.hide(SORT_COLUMNS.file),
          },
        ]}
        displayMode
        data={tableData}
      /> */}
    </TopbarPage>
  );
};

export default Balance;
